import React, { useEffect } from "react";
import data from "../assests/JSON/AboutEinv.json";
import "../styles/Einv.css";
import "../styles/landing.css";
import Footer from "../components/Footer";
import Navigation from "../components/Navbar";
import Latestupdate from "../components/Latestupdate";
import EinvProcess from "../components/EinvProcess";
import Seo from "../components/Seo";

const Einv = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on page load
  }, []);
  return (
    <>
        <Seo path="/einv" />
      <Navigation />
      <div className="einv-container">
        <h1 className="einv-title">{data.title}</h1>
        <div className="einv-meta">
          <span>By {data.author}</span>
          <span> | Updated on: {data.updatedOn}</span>
          <span> | {data.readTime}</span>
        </div>

        <div className="einv-content">
          {data.content.map((section, idx) => {
            if (section.type === "heading") {
              return (
                <h3 key={idx} className="einv-heading">
                  {section.text}
                </h3>
              );
            }
            return (
              <p key={idx} className="einv-paragraph">
                {section.text}
              </p>
            );
          })}
        </div>
        <div>
          <Latestupdate />
          <EinvProcess />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Einv;
